/// <reference path="../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";

import * as Rest from "../Generated/RestClient";
import {NavLinks} from "../../../Intercom.ReactUI/Views/JumboHeadControl";
import {SearchControl} from "../../../Intercom.ReactUI/Views/SearchControl";
import {JumboHeadControl} from "../../../Intercom.ReactUI/Views/JumboHeadControl";
import {DropdownMenu, DropdownMenuItem} from "./DropdownMenu";
import {HeaderControl} from "../../../Intercom.ReactUI/Views/HeaderControl";
import {FooterControl} from "../../../Intercom.ReactUI/Views/FooterControl";
import {ProgressBarControl} from "../../../Intercom.ReactUI/Views/ProgressBarControl";
import {resourceStrings} from "../../../Intercom.ReactUI/Views/Strings";
import {clientAppSettings} from "../Models/ClientAppSettings";
import {relativeUrl} from "../Utils/Links";
import isInFrame from "../../../Intercom.ReactUI/Utils/InFrame";
import { EmailSubscriptionConsentConductor } from '../Controllers/EmailSubscriptionConsent';
import {isBrowserSupported}  from "../Controllers/ControllerBase";

export interface SearchablePageProps {
    onSearch: (s: string) => void;
}

export interface MasterPageProps extends SearchablePageProps {
    signInRequired: boolean;
    isAdmin: () => boolean;
    isReviewer: () => boolean;
    onSignOutClicked: () => void;
    refreshSignedInUser: () => void;
    isRoutableUrl: (url: string) => boolean;
}

export interface MasterPageState {
    signInState: string;
    signedInUser: Rest.AuthData;
    signInInProgress: boolean;
    signInError: string;
    activeLink: NavLinks
    searchString?: string;
    expandSearch?: boolean;
    unsupportedBrowser?: boolean;
}

export class MasterPage extends React.Component<MasterPageProps, MasterPageState> {
    private singleSignOnChecker: HTMLIFrameElement;
    private emailSubscriptionConsent: EmailSubscriptionConsentConductor;

    constructor(props) {
        super(props);
        this.state = {
            signInState: null,
            signedInUser: null,
            signInInProgress: false,
            signInError: null,
            activeLink: NavLinks.root
        };

        this.emailSubscriptionConsent = new EmailSubscriptionConsentConductor();
    }

    render() : JSX.Element {
        if (this.state.unsupportedBrowser) {
            return this.renderUnsupportedBrowser();
        } else if (this.state.signInState) {
            return this.renderWaitListScreen();
        } else if (this.props.signInRequired && !this.state.signedInUser) {
            return this.renderSignInScreen();
        } else {
            return this.renderRegularScreen();
        }
    }

    public componentWillUpdate(nextProps: MasterPageProps, state: MasterPageState) {
        var jumbo = this.refs['jumbo'] as JumboHeadControl;
        if (jumbo) {
            jumbo.setState({ activeLink: state.activeLink });
        }

        var search = this.refs['searchBox'] as SearchControl;
        if (search) {
            search.setState({ searchString: state.searchString });
        }
    }

    public componentDidUpdate(prevProps: MasterPageProps, prevState: MasterPageState) {
        if (this.state.signedInUser) {
            this.emailSubscriptionConsent.showIfRequired();
        }
    }

    private toggleSearch() {
        var opened = _.isUndefined(this.state.expandSearch) ? true : !this.state.expandSearch;
        this.setState(_.extend(this.state, { expandSearch: opened }));
    }

    private userFlightedDocuemntationLink(): string {
        var features = clientAppSettings.flightedFeatures;
        if (_.indexOf(features, "v3") >= 0) {
            return '//aka.ms/bf-docs-nav';
        } else {
            return clientAppSettings.documentationUrl;
        }
    }

    private getSignInUrl(): string {
        const paramValue = encodeURIComponent(relativeUrl(window.location));
        return `/identity/signin?requestUrl=${paramValue}`;
    }

    private checkAzureSingleSignOn() {
        let host = null;
        try {
            host = this.singleSignOnChecker.contentWindow.location.hostname;
        } catch (error) {
            host = null;
        }
        if (host) {
            const curHost = window.location.hostname;
            if (host === curHost) {
                // user already logged in azure, fetched user and re-render
                this.props.refreshSignedInUser();
            }
        }
    }

    private renderHiddenFrameToCheckAzureSingleSignOn(): JSX.Element {
        return null;
    }

    renderHeader(showLinks: boolean = true): JSX.Element {
        if (isInFrame()) {
            return null;
        }
        let navLinks: string[] = [];
        let userInfo = null as JSX.Element;
        let searchControl = null as JSX.Element;

        if (showLinks) {
            navLinks = [
                '/bots',
                '/bots/new',
                this.userFlightedDocuemntationLink(),
                clientAppSettings.homeUrl,
                'http://blog.botframework.com'
            ];

            if (this.state.signedInUser) {
                userInfo = (
                    <span>
                        <div className="signed-in-user">{this.state.signedInUser.FirstName || this.state.signedInUser.EmailAddress }</div>
                    </span>
                );
            }
            else {
                userInfo = (
                    <div className="header-login">
                        <a data-test-id="sign-in" className="header-sign-in-button"
                            onClick={evt => {
                                if (!isBrowserSupported()) {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    this.setState({ unsupportedBrowser: true } as any);
                                }
                            }}
                            href={this.getSignInUrl()}>
                            Sign in
                        </a>
                        {this.renderHiddenFrameToCheckAzureSingleSignOn()}
                    </div>);
            }

            searchControl = this.props.isAdmin() || this.props.isReviewer() ? (
                <SearchControl ref="searchBox" onSearch={this.props.onSearch}
                    value={null}
                    expandSearch={this.state.expandSearch}
                    promptText={clientAppSettings.searchPrompt}
                    toggleSearchOpen={_.debounce(_.bind(this.toggleSearch, this), 100, true) }/>
            ) : null;
        }

        let userMenu = null;
        if (this.state.signedInUser) {
            userMenu = (
                <DropdownMenu ref="userMenu" classNames="user-menu">
                    <DropdownMenuItem notSelectable={true}>
                        <div className="user-menu-user">
                            <div className="user-menu-user-name">{this.state.signedInUser.FirstName} {this.state.signedInUser.LastName}</div>
                            <div className="user-menu-user-email">{this.state.signedInUser.EmailAddress}</div>
                        </div>
                    </DropdownMenuItem>
                    <DropdownMenuItem onSelected={() => this.props.onSignOutClicked() }>
                        Sign out
                    </DropdownMenuItem>
                </DropdownMenu>
            );
        }

        return (
            <div>
                {userMenu}
                <HeaderControl
                    environment={clientAppSettings.environment}>
                    <div className="rhs">
                        {userInfo}
                    </div>
                </HeaderControl>
                <JumboHeadControl
                    ref="jumbo"
                    rootUrl={clientAppSettings.homeUrl || '/'}
                    defaultLink={NavLinks.root}
                    navLinks={navLinks}
                    isRoutable={this.props.isRoutableUrl}
                    >
                    {searchControl}
                </JumboHeadControl>
            </div>
        );
    }

    renderRegularScreen(): JSX.Element {
        let footer = isInFrame() ? null : (
            <FooterControl>
                <li><a href="//aka.ms/bf-terms">Terms of use</a></li>
                <li><a href="//aka.ms/bf-conduct">Code of conduct</a></li>
            </FooterControl>
            );
        return (
            <div className="fullWidth">
                {this.renderHeader() }
                <section className="action-sheet">
                </section>
                <main className="outline">
                    <div className="page-content"></div>
                    <ProgressBarControl/>
                </main>
                {footer}
            </div>
        );
    }

    renderUnsupportedBrowser(): JSX.Element {
        return (
            <div className="sign-in-screen">
                { this.renderHeader() }
                <div className="sign-in-contents">
                    <div className="sign-in-title">{isInFrame() ?
                        "The Azure Bot Service doesn't support your browser yet." :
                        "Bot Framework doesn't support your browser yet."}
                    </div>
                </div>
            </div>);
    }

    renderWaitListScreen(): JSX.Element {
        return null;
    }

    renderSignInScreen(): JSX.Element {
        var bottomPanel: JSX.Element;
        var errorMessagePanel: JSX.Element;
        if (isInFrame()) {
            return null;
        }
        if (this.state.signInInProgress) {
            bottomPanel = (
                <div>
                    <div className="sign-in-progress-text">Signing in...</div>
                    <div className="sign-in-progress-animation"></div>
                </div>
            );
        }
        else {
            bottomPanel = (
                <div className="button-panel">
                    <a href={this.getSignInUrl() }><button type="button" className="sign-in default-button">Sign in</button></a>
                    {this.renderHiddenFrameToCheckAzureSingleSignOn()}
                </div>
            );
        }

        if (this.state.signInError) {
            errorMessagePanel = <div className="sign-in-error">{this.state.signInError}</div>;
        }

        return (
            <div className="sign-in-screen">
                { this.renderHeader(false) }
                <div className="sign-in-contents">
                    <div className="sign-in-title">Sign in</div>
                    <div className="sign-in-details">
                        <div>Welcome to {resourceStrings.botFramework} developer portal.</div>
                        <div>To continue sign in with your work or school, or personal Microsoft account.</div>
                    </div>
                    {bottomPanel}
                    {errorMessagePanel}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/Views/MasterPage.tsx